import { FC, useCallback, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";
import Swal from "sweetalert2";
import useAccessToken from "../../../hooks/AccessToken";
import axios from "axios";
import useSWR, { mutate } from "swr";
import { Progress } from "../../../interfaces/Progress";
import { CustomFieldType, insertLog } from "../../../api/LogsCRUD";
import { useDataTableStore } from "../../../stores/DataTableStore";
import { ListProduct, Pipeline } from "../../../interfaces/Pipeline";
import { RecentChatHistoryPipeline } from "../../../interfaces/Chat/RecentChatHistory";
import { insertAttachment, insertMultiAttachment } from "../../../api/ResourceAPI";
import { Modal } from "bootstrap";
import { useChatStore } from "../../../stores/ChatStore";
import { KTSVG } from "../../../_metronic/helpers";
import { getDateRangeDuration, isAfterToday, isValidUrl, getDataById, getCurrencySymbol, currencyFormatter, parseFormattedCurrency, roundDecimalToTwo, currencyFormatterPreventPropagation, sanitizeTagHtml, changeValueIfStringIntoNumber, calculateProductTotal, customThousandSeparatorDot } from "../../../functions/general";
import useUser from "../../../hooks/User";
import moment from "moment";
import { useIntl } from "react-intl";
import { useNavigate, useParams } from "react-router-dom";
import InputAttachment from "../../Input/InputAttachment";
import { useCustomeStore } from "../../../stores/CustomeStore";
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import ImageModal from "./ImageModal";
import { checkIsProgressUTMorUTJTanrise, showSerial } from "../../../functions/customCase";
import { DatePicker } from "rsuite";
import useTodayRange from "../../../hooks/TodayRange";
import { createPaymentTermin, ICreatePaymentTermin } from "../../../api/PipelineCRUD";
import { CustomField } from "../../../interfaces/Settings";
import PaymentTerminDisplay from "../../DataTableTermin/PaymentTerminDisplay";
import RenderTerminCustomFieldLog from "../RenderCustomFieldTermin/RenderTerminCustomFieldLog";
import { usePipelineStore } from "../../../stores/PipelineStore";
import { Switch } from "@mui/material";
import InputAttachmentTermin from "../DetailTermin/InputAttachmentTermin";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { fetchWithToken } from "../../../api/General";
import { formats } from "./utilityReactQuill";
import { ALWAYS_REQUIRED_FIELDS_PROOF_OF_PAYMENT, MAX_FILE_SIZE } from "../../../constant/General";
import { useMerchantStore } from "../../../stores/MerchantStore";
import { useUserStore } from "../../../stores/UserStore";
import { useDNDPipelineStore } from "../../../stores/DNDPipelineStore";
import VirtualizedSelect from "../../Select/SelectVirtualized";
import RenderCustomFieldGeneralForm from "../../RenderComponent/RenderCustomFieldGeneralForm";
import { PaymentTermin, TempPaymentTermin } from "../../../interfaces/Termin/Termin";
import EastIcon from '@mui/icons-material/East';
import { InvoiceMultiPageSetting } from "../../../interfaces/Invoices";
import { InvoiceAttachments } from "./InvoiceAttachments";
import { getInvoiceGeneratedByLatest } from "../../../api/InvoicesCRUD";
import { Badge } from "react-bootstrap";
import { useMeetingStore } from "../../../stores/MeetingsStore";
import { convertUrlsToLinks, getBase64, processDescriptionImages } from "../../../functions/HandlePasteLog/handlePasteLog";
import 'quill-mention';
import { useProductStore } from "../../../stores/ProductStore";
import useLogLeadTempStore from "../../../stores/LogLeadTemp";
import { LogLeadTemp } from "../../../interfaces/LogLeadTemp";
import { v4 as uuidv4 } from 'uuid';
import ListProductPipeline from "../ProductPipeline/ListProductPipeline";
import ProductPipelineMain from "../ProductPipeline/ProductPipelineMain";
import useModalEffectResponsive from "../../../hooks/useModalEffectResponsive";
import { AccessLeadTemplate } from "../../../interfaces/AccessLeadTemplate";
import { getSelectedAccessLeadTemplate } from "../../../functions/leadTemplateAccess";
import { Label } from "../../../interfaces/Label";
import Select from "react-select";


interface CustomFields {
    [key: string]: string | string[] | File | File[]
}

export interface AddLogFormValues {
    progress: string
    subProgress: string
    description: string
    attachment: null | File[]
    update_product_hpp: boolean
    isRequiredAttachment: boolean
    [key: string]: any
    terminForm: {
        isTerminEnabled: boolean
        inputType: string
        nominal: string
        vatPercentage: string
        dateDue: string
        datePaid: string
        receiptUrls: File[] | File | null
        customFields: CustomFieldType
        togglePayment: boolean
        isPaymentDP: boolean
    }
}

interface SelectOption {
    value: string;
    label: string;
    isRequiredUpdateProductHpp?: boolean;
    isRequiredAttachment?: boolean;
    editLeadProductAccess: {
        create: boolean;
        delete: boolean;
        edit: {
            price: boolean;
            quantity: boolean;
            cogs: boolean;
        }
    }
    typeProgress?: string;
    isSplittable?: boolean;
}

interface AddLogProps {
    lead: Pipeline | RecentChatHistoryPipeline
    showModal: boolean
    setShowModal: React.Dispatch<React.SetStateAction<boolean>>
    showAddLogButton?: boolean
    setLead?: any
    progress?: any
    setProgress?: any
    progresses?: any
    progressesLoading?: boolean
    dateFilter?: {
        typeDateFilter: string
        startDate: Date | string
        endDate: Date | string
    }
    typeLog?: 'default' | 'log-lead-temp'
    typeAction?: 'add' | 'edit'
    logLeadTemp?: LogLeadTemp
    showMasterLogModal?: boolean
}

const API_URL = process.env.REACT_APP_API_URL

const AddLog: FC<AddLogProps> = ({ lead, showModal, setShowModal, showAddLogButton, setLead, progress, setProgress, dateFilter, typeLog = 'default', typeAction = 'add', logLeadTemp, showMasterLogModal }) => {
    const todayRange = useTodayRange();
    const { selectMultiPipeline, simplePipelines, selectedPipelineLogTemp, setSelectedPipelineLogTemp } = usePipelineStore()
    const { simpleMeetings } = useMeetingStore()
    const { simpleProducts, setTypeActionProduct, setProductTemp } = useProductStore()
    const { setCurrentDraggedPipelineCard, setIsCardDragging } = useDNDPipelineStore()
    const { chatSelectedPipeline } = useChatStore()
    const { companyId, keyCustomfield, progressId, databasePipelineId } = useCustomeStore()
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [subProgressesLoading, setIsLoadingSubProgresses] = useState(false);
    const { tablesData, setTablesData, fetchCounter, setFetchCounter } = useDataTableStore()
    const modalRef = useRef<HTMLDivElement | null>(null);
    const closeModalRef = useRef<HTMLButtonElement>(null);
    const [progressesData, setProgressesData] = useState<SelectOption[]>([]);
    const [subProgressesData, setSubProgressesData] = useState<SelectOption[]>([]);
    const token = useAccessToken()
    const user = useUser()
    const { templatePipelineId } = useParams();
    const [listProducts, setListProducts] = useState<ListProduct[]>([]);
    const navigate = useNavigate()
    const quillRef = useRef<ReactQuill>(null)
    const [modalImage, setModalImage] = useState({ show: false, url: '', title: '' });
    const [typeProgress, setTypeProgress] = useState('')
    const [toggleCheckbox, setToggleCheckbox] = useState(true)
    const [tempPaymentTermin, setTempPaymentTermin] = useState<TempPaymentTermin[]>([])
    const [customFieldTermin, setCustomFieldTermin] = useState<CustomField>({})
    const [customFields, setCustomFields] = useState<CustomField>({})
    const [labelLoading, setLabelLoading] = useState(false);
    const [labelsData, setLabelsData] = useState<SelectOption[]>([]);
    const checkingValuePaymentTerm = (): number => {
        if (typeof lead.nominal === 'number') {
            if (selectMultiPipeline.currencyIsRounded) {
                return Math.round(lead.nominal)
            }
            return lead.nominal
        }
        return Number(parseFormattedCurrency(lead.nominal))
    }
    const [remainingAmount, setRemainingAmount] = useState<number>(checkingValuePaymentTerm())
    const [isSplitTableTermin, setIsSplitTableTermin] = useState(false)
    const [terminErrors, setTerminErrors] = useState<any>({})
    const refArray = useRef<(HTMLInputElement | HTMLTextAreaElement | null)[]>([]);
    const [shouldDate, setShouldDate] = useState<Date | null>()
    const { simpleMerchants } = useMerchantStore()
    const { users } = useUserStore()
    const [validationSchema, setValidationSchema] = useState<any>(null);
    const { settings } = useSettingsStore()
    const [selectInvoice, setSelectInvoice] = useState<InvoiceMultiPageSetting | null>(null)
    const [hasInvoiceSettings, setHasInvoiceSettings] = useState(false)
    const [stepForm, setStepForm] = useState<number>(0)
    const [modalBtnLoading, setModalBtnLoading] = useState<boolean>(false)
    const [defaultValueProgress, setDefaultValueProgress] = useState()
    const [quillModules, setQuillModules] = useState({
        toolbar: [
            [{ header: [1, 2, false] }],
            ['bold', 'italic', 'underline', 'strike', 'link'],
        ],
        mention: {
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@"],
            source: async function (searchTerm: string, renderList: Function) {
                const mentions = await suggestPeople(searchTerm);
                const values = mentions.map((user: any) => ({
                    id: user.id,
                    value: `@${user.username}`,
                }));
                renderList(values, searchTerm);
            },
            onSelect: (item: any, insertItem: Function) => {
                insertItem(item);
            },
            showDenotationChar: false,
            renderItem: (item: any, searchTerm: string) => {
                return `<div class="mention-item">
                <span class="mention-name">${item.value}</span>
                </div>`;
            },
        },
    });
    const totalNominalPipeline = listProducts.reduce((acc, product) => acc + changeValueIfStringIntoNumber(product.leadProductTotal), 0)
    const [selectedProgress, setSelectedProgress] = useState<Progress>();
    const { addLogLeadByTemplatePipelineId, updateLogLeadTempByIdLog } = useLogLeadTempStore()
    const [showModalAddProduct, setShowModalAddProduct] = useState<boolean>(false);
    const [dataLeadAccess, setDataLeadAccess] = useState<AccessLeadTemplate | null>(null)
    const [isLoadingLeadAccess, setIsLoadingLeadAccess] = useState<boolean>(false)

    const { data: userMentionData = [], isLoading: userMentionLoading } = useSWR([`${API_URL}user-lead?leadId=${lead.id}`, token], fetchWithToken)
    const { data: progresses = [], error: progressesError, isLoading: progressesLoading } = useSWR(
        [`${API_URL}lead_progresses?onlyShowAllowedForCreateLeadLog=true&leadTemplateId=${lead.lead_template_id}&leadId=${lead.id}`, token],
        fetchWithToken
    );
    const { data: invoiceSettings = [], error: invoiceSettingsError, isLoading: invoiceSettingsLoading } = useSWR(
        [`${API_URL}invoices/settings/?leadTemplateId=${lead.lead_template_id}`, token],
        fetchWithToken
    );

    useEffect(() => {
        if (userMentionData.length > 0 && !userMentionLoading) {
            setQuillModules({
                ...quillModules,
                mention: {
                    ...quillModules.mention,
                    source: async function (searchTerm: string, renderList: Function) {
                        const mentions = await suggestPeople(searchTerm);
                        const values = mentions.map((user: any) => ({
                            id: user.id,
                            value: `@${user.username}`,
                        }));
                        renderList(values, searchTerm);
                    }
                }
            })
        }

    }, [userMentionData, userMentionLoading])

    // get Data Lead Template Access
    useEffect(() => {
        if (templatePipelineId) {
            setIsLoadingLeadAccess(true)
            getSelectedAccessLeadTemplate(templatePipelineId, token, setDataLeadAccess)
            setIsLoadingLeadAccess(false)
        } else {
            setIsLoadingLeadAccess(true)
            getSelectedAccessLeadTemplate(lead.lead_template_id, token, setDataLeadAccess)
            setIsLoadingLeadAccess(false)
        }
    }, [templatePipelineId])

    useEffect(() => {
        if (settings.termins_custom_fields) {
            setCustomFieldTermin(JSON.parse(settings.termins_custom_fields))
        }
    }, [settings])

    useEffect(() => {
        if (Object.keys(selectMultiPipeline).length !== 0) {
            setCustomFields(selectMultiPipeline.customFields)
        }
    }, [selectMultiPipeline])

    const intl = useIntl()

    // const handleHppChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    //     const value = e.target.value ?? 0;
    //     leadProductsData[index].hpp = Number(value.replaceAll(",", ""))
    //     setLeadProductsData([...leadProductsData])
    // };

    const validateTerminForm = (values: any, customFieldTermin: CustomField, togglePayment: boolean) => {
        const errors: any = {};
        // Validate nominal
        if (values.nominal === 0 || values.nominal === '0') {
            errors.nominal = intl.formatMessage({ id: "FORM.LABEL.PAYMENT_AMOUNT_0" })
        }

        if (values.nominal === '') {
            errors.nominal = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.PAYMENT_AMOUNT" }) });
        }

        // Validate dateDue
        if (values.dateDue === '' && !togglePayment) {
            errors.dateDue = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DEADLINE_PAYMENT" }) });
        }

        if (values.datePaid === '' && togglePayment) {
            errors.datePaid = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DATE_PAID" }) });
        }

        if (ALWAYS_REQUIRED_FIELDS_PROOF_OF_PAYMENT.includes(formik.values.progress) && !values.receiptUrls) {
            errors.receiptUrls = intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.PROOF_OF_PAYMENT_TERM" }) });
        }

        // Validate custom fields
        if (customFieldTermin) {
            const customFieldErrors: any = {};
            Object.entries(customFieldTermin).forEach(([key, field]) => {
                const value = values.customFields?.[key];

                // Check for required fields
                if (field.required) {
                    // For file type fields
                    if (['image', 'images', 'file', 'files', 'video', 'videos'].includes(field.type)) {
                        if (!value || (Array.isArray(value) && value.length === 0)) {
                            customFieldErrors[key] = intl.formatMessage(
                                { id: "FORM.VALIDATION.FIELD_REQUIRED" },
                                { title: field.name || 'Custom Field' }
                            );
                        }
                    }
                    // For non-file type fields
                    else if (!values.customFields || !value) {
                        customFieldErrors[key] = intl.formatMessage(
                            { id: "FORM.VALIDATION.FIELD_REQUIRED" },
                            { title: field.name || 'Custom Field' }
                        );
                    }
                }

                // Validate URL for link type fields
                if (field.type === 'link' && value) {
                    try {
                        new URL(value);
                    } catch (e) {
                        customFieldErrors[key] = intl.formatMessage({ id: 'FORM.VALIDATION.MUST_LINK' });
                    }
                }
            });
            if (Object.keys(customFieldErrors).length > 0) {
                errors.customFields = customFieldErrors;
            }
        }

        return errors;
    };

    document.querySelectorAll('.ql-tooltip .ql-editing input').forEach(function (input) {
        input.classList.add('txt-log');
    });

    const isLabelRequired = (id: string) => {
        return (
            process.env.NODE_ENV === 'development'
                ? id && id === progressId.updateLabel && user.data.company_id === companyId.looyalIT
                : id && id === progressId.updateLabel && user.data.company_id === companyId.tkd && databasePipelineId.includes(templatePipelineId!)
        )
    }

    const formik = useFormik<AddLogFormValues>({
        initialValues: {
            progress: progress ? progress : "",
            subProgress: typeAction === 'edit' && logLeadTemp ? logLeadTemp?.subProgressId : '',
            description: typeAction === 'edit' && logLeadTemp ? logLeadTemp?.description : '',
            attachment: typeAction === 'edit' && logLeadTemp ? logLeadTemp?.attachments as File[] : null,
            labels: typeAction === 'edit' && logLeadTemp ? logLeadTemp?.labelIds : (lead as Pipeline).labels.length ? (lead as Pipeline).labels.map((label) => { return label.id }) : [],
            update_product_hpp: false,
            isRequiredAttachment: false,
            ...Object.fromEntries(Object.keys(customFields).flatMap((key) => {
                const leadPipeline = typeAction === 'edit' && logLeadTemp ? logLeadTemp?.customFields : lead.custom_fields as any
                if (customFields[key].type === 'invoice_reminder') {
                    return [
                        [`${key}_invoice_url`, leadPipeline[key] && JSON.parse(leadPipeline[key] as string).invoice_url ? JSON.parse(leadPipeline[key] as string).invoice_url : null],
                        [`${key}_date_due`, leadPipeline[key] && JSON.parse(leadPipeline[key] as string).date_due ? JSON.parse(leadPipeline[key] as string).date_due : null]
                    ];
                } else {
                    return [
                        [key,
                            leadPipeline && leadPipeline[key] ?
                                customFields[key].type === 'date' ?
                                    moment(leadPipeline[key], 'YYYY-MM-DD', true).isValid() ?
                                        leadPipeline[key]
                                        : null
                                    : leadPipeline[key]
                                : null]
                    ];
                }
            })),
            terminForm: {
                isTerminEnabled: false,
                inputType: 'nominal',
                nominal: '',
                vatPercentage: '',
                dateDue: '',
                datePaid: '',
                receiptUrls: null,
                customFields: {},
                togglePayment: false,
                isPaymentDP: false
            }
        },
        validationSchema: validationSchema,
        enableReinitialize: true,
        validateOnMount: true,
        validateOnChange: true,
        validateOnBlur: true,
        onSubmit: async (values, { setSubmitting }) => {
            setSubmitting(true)
            setModalBtnLoading(true)

            if (selectMultiPipeline.isFeatureCogsEnabled && selectedProgress?.isRequiredUpdateProductHpp) {
                const checkHppProduct = listProducts.some(product => product.leadProductHpp === null); //Number(product.leadProductHpp) === 0 || 
                if (checkHppProduct) {
                    setModalBtnLoading(false)
                    Swal.fire({
                        icon: 'error',
                        title: intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.HPP" }) }),
                        confirmButtonText: 'Ok'
                    })
                    setSubmitting(false)
                    return
                }
            }

            const getFormatCurrency = currencyFormatter((remainingAmount).toString(), selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode)

            if (remainingAmount > 0 && !toggleCheckbox) {
                Swal.fire({
                    icon: 'error',
                    title: intl.formatMessage({ id: intl.formatMessage({ id: "FORM.LABEL.REMAINING_AMOUNT_UNPAYMENT" }) }),
                    text: intl.formatMessage({ id: intl.formatMessage({ id: "FORM.LABEL.DYNAMIC_REMAINING_AMOUNT" }, { title: `${user.data.companyCurrency === "IDR" ? "Rp" : "$"} ${getFormatCurrency}` }) }),
                    confirmButtonText: 'Ok'
                })
                setSubmitting(false)
                return
            }
            const customFieldsValues: Record<string, string | string[] | null> = Object.keys(customFields).reduce(
                (obj, item) => ({
                    ...obj,
                    [item]: (values as Record<string, string | string[] | null>)[item],
                }),
                {}
            );

            const convertCustomFields: Record<string, any> = Object.keys(customFields).reduce(
                (obj, item) => {
                    if (!obj.info_custom_fields) {
                        obj.info_custom_fields = {};
                    }

                    if (customFields[item].type === 'merchant') {
                        const selectedMerchants = getDataById(values[item as keyof typeof values] as any, simpleMerchants);
                        obj[`custom_fields.${item}`] = selectedMerchants?.map((merchant: any) => merchant.name).join(", ");
                        obj.info_custom_fields[item] = selectedMerchants?.map((merchant: any) => ({
                            merchant_template_id: merchant.merchantTemplateId,
                            merchant_id: merchant.id,
                            merchant_name: merchant.name
                        })) || [];
                    }
                    else if (customFields[item].type === 'user') {
                        const selectedUsers = getDataById(values[item as keyof typeof values] as any, users);
                        obj[`custom_fields.${item}`] = selectedUsers?.map((user: any) => user.name).join(", ");
                        obj.info_custom_fields[item] = selectedUsers?.map((user: any) => ({
                            id: user.id,
                            name: user.name
                        })) || [];
                    }
                    else if (customFields[item].type === 'pipeline') {
                        const selectedPipeline = getDataById(values[item as keyof typeof values] as string, simplePipelines);
                        obj[`custom_fields.${item}`] = selectedPipeline ?
                            `${selectedPipeline.name} / ${selectedPipeline.nominal} / ${moment(selectedPipeline.dateCreated).format('DD MMM YYYY')}`
                            : '-';
                        obj.info_custom_fields[item] = selectedPipeline ? [{
                            id: selectedPipeline.id,
                            name: selectedPipeline.name,
                            nominal: selectedPipeline.nominal,
                            dateCreated: selectedPipeline.dateCreated
                        }] : [];
                    }
                    else if (customFields[item].type === 'meeting') {
                        const selectedMeeting: any[] = getDataById(values[item as keyof typeof values] as string, simpleMeetings);
                        obj[`custom_fields.${item}`] = selectedMeeting && selectedMeeting.length > 0 ?
                            selectedMeeting.map((meeting: any) => `${meeting.name} / ${moment(meeting.dateMeet).format('DD MMM YYYY')} / ${meeting.meetingStatus}`).join(', ')
                            : '-';
                        obj.info_custom_fields[item] = selectedMeeting && selectedMeeting.length > 0 ? selectedMeeting.map((meeting: any) => ({
                            meeting_template_id: meeting.meetingTemplateId,
                            id: meeting.id,
                            merchant_name: meeting.name,
                            date_meet: meeting.dateMeet,
                            meeting_status: meeting.meetingStatus
                        })) : [];
                    } else if (customFields[item].type === 'product') {
                        const selectedProducts = getDataById(values[item as keyof typeof values] as any, simpleProducts);
                        obj[`custom_fields.${item}`] = selectedProducts?.map((product: any) => product.name).join(", ");
                        obj.info_custom_fields[item] = selectedProducts?.map((product: any) => ({
                            product_id: product.id,
                            product_name: product.name,
                            product_prices: product.product_prices,
                        })) || [];
                    }
                    else {
                        obj[`custom_fields.${item}`] = values[item as keyof typeof values] || '';
                        obj.info_custom_fields[item] = [];
                    }

                    return obj;
                },
                {} as Record<string, any>
            );

            const descriptionWithLinks = convertUrlsToLinks(values.description);
            const processDescription = await processDescriptionImages(descriptionWithLinks, token);

            let attachment: { name: string, url: string }[] = []
            if (values.attachment && typeLog === 'default') {
                const resourceResponse = await insertMultiAttachment(values.attachment, 'PIPELINE', token)
                resourceResponse.data.data.forEach((fileData: string, index: number) => {
                    const fileName = `file-${Date.now()}-${index}`;
                    attachment.push({
                        name: fileName,
                        url: fileData
                    });
                });
            }

            var countResourceError = 0
            await Promise.all(
                Object.keys(customFields).map(async (key) => {
                    if (typeLog === 'default') {
                        if (customFields[key].type === 'image' || customFields[key].type === 'file' || customFields[key].type === 'video') {
                            try {
                                if (values[key as keyof typeof values] && typeof values[key as keyof typeof values] === 'object') {
                                    const resourceResponse = await insertAttachment(values[key as keyof typeof values]!, 'PIPELINE', token);
                                    if (resourceResponse.data.success) customFieldsValues[key] = resourceResponse.data.data.length > 0 ? resourceResponse.data.data[0] : null;
                                    else countResourceError++
                                }
                            } catch (error) {
                                countResourceError++
                            }
                        } else if (customFields[key].type === 'images' || customFields[key].type === 'files' || customFields[key].type === 'videos') {
                            try {
                                if (values[key as keyof typeof values]) {
                                    var dataMultiAttachment = (values[key as keyof typeof values] as any).filter((item: any) => typeof item !== 'string')
                                    var dataUrlAttachment = (values[key as keyof typeof values] as any).filter((item: any) => typeof item === 'string')

                                    const resourceResponse = await insertMultiAttachment(dataMultiAttachment, 'PIPELINE', token);
                                    if (resourceResponse.data.success) (customFieldsValues[key] as any) = resourceResponse.data.data.length > 0 ? [...dataUrlAttachment, ...resourceResponse.data.data] : dataUrlAttachment.length > 0 ? dataUrlAttachment : null;
                                    else countResourceError++
                                }
                            } catch (error) {
                                countResourceError++
                            }
                        } else if (customFields[key].type === 'number') {
                            const stringValue = values[key as keyof typeof values] as string;
                            customFieldsValues[key] = stringValue ? customThousandSeparatorDot(stringValue as unknown as number) : null;
                        }
                    }
                })
            );

            if (countResourceError > 0) {
                Swal.fire({
                    icon: "error",
                    text: `${intl.formatMessage({ id: "FORM.VALIDATION.ADD_FAILED" })}.`,
                    heightAuto: false,
                    confirmButtonText: 'Ok'
                })
                setSubmitting(false);
            } else if (typeLog === 'default') {
                try {
                    let tempDataTermin: any[] = []
                    const newValueProducts = listProducts.map((product) => ({
                        ...product,
                        leadProductHpp: product.leadProductHpp ? changeValueIfStringIntoNumber(product.leadProductHpp as unknown as number) : null,
                        leadProductPrice: changeValueIfStringIntoNumber(product.leadProductPrice),
                        leadProductTotal: changeValueIfStringIntoNumber(product.leadProductTotal),
                        leadProductDiscount: changeValueIfStringIntoNumber(product.leadProductDiscount as unknown as number)
                    }))
                    const leadLabels = values.labels.length > 0 && Array.isArray(values.labels) && labelsData.length > 0 ? values.labels.map((label: string) => { return { id: label, name: labelsData.filter((option: any) => option.value === label)[0]['label'] } }) : []
                    const response = selectMultiPipeline.isFeatureCogsEnabled && values.update_product_hpp
                        ? await insertLog(
                            token,
                            lead.id,
                            processDescription,
                            values.progress,
                            values.subProgress,
                            attachment,
                            // leadProductsData,
                            newValueProducts,
                            // selectMultiPipeline.isFeatureCogsEnabled ? leadProductsData : [],
                            customFieldsValues,
                            leadLabels
                        )
                        : await insertLog(
                            token,
                            lead.id,
                            processDescription,
                            values.progress,
                            values.subProgress,
                            attachment,
                            // leadProductsData,
                            newValueProducts,
                            // leadProductsData.map(product => ({
                            //     ...product,
                            //     hpp: 0
                            // })),
                            customFieldsValues,
                            leadLabels
                        );

                    if (response.data.success) {
                        setSelectedProgress(undefined)
                        setListProducts([])

                        if (tempPaymentTermin.length > 0) {
                            for (let termin of tempPaymentTermin) {
                                if (termin.customFields) {
                                    let processedCustomFields: { [key: string]: any } = { ...termin.customFields };

                                    for (const [key, value] of Object.entries(termin.customFields)) {
                                        if (value instanceof File) {
                                            // Handle single file upload
                                            const response = await insertAttachment(value, 'PIPELINE', token);
                                            if (!response.data.success) {
                                                Swal.fire({
                                                    icon: 'error',
                                                    title: response.data.message,
                                                    confirmButtonText: 'Ok',
                                                })
                                                return;
                                            }
                                            processedCustomFields[key] = response.data.success ? response.data.data[0] : null;
                                        } else if (Array.isArray(value) && value.some(item => item instanceof File)) {
                                            // Handle multiple files upload
                                            const files = value.filter(item => item instanceof File);
                                            if (files.length > 0) {
                                                const response = await insertMultiAttachment(files, 'PIPELINE', token);
                                                if (!response.data.success) {
                                                    Swal.fire({
                                                        icon: 'error',
                                                        title: response.data.message,
                                                        confirmButtonText: 'Ok',
                                                    })
                                                    return;
                                                }
                                                processedCustomFields[key] = response.data.success ? response.data.data : null;
                                            }
                                        } else if (termin.customFields && termin.customFields[key] && typeof termin.customFields[key] === 'string') {
                                            const stringValue = termin.customFields[key] as string;
                                            termin.customFields[key] = stringValue ? customThousandSeparatorDot(stringValue as unknown as number) : null;
                                        }
                                    }
                                    termin.customFields = processedCustomFields;
                                }
                                if (termin.receiptUrls && typeof termin.receiptUrls === 'object' && termin.receiptUrls instanceof File) {
                                    const attachment = await insertAttachment(termin.receiptUrls, 'PIPELINE', token);
                                    if (!attachment.data.success) {
                                        Swal.fire({
                                            icon: 'error',
                                            title: attachment.data.message,
                                            confirmButtonText: 'Ok',
                                        })
                                        return;
                                    }
                                    termin.receiptUrls = [attachment.data.success ? attachment.data.data[0] : null];
                                }

                                const newValues: ICreatePaymentTermin = {
                                    leadId: lead.id,
                                    nominal: termin.nominal,
                                    dateDue: termin.dateDue || null,
                                    datePaid: termin.datePaid || null,
                                    progress: termin.progress === 'PAID' ? 'PAID' : 'PENDING',
                                    receiptUrls: termin.receiptUrls || [],
                                    customFields: termin.customFields,
                                    vatPercentage: termin.vatPercentage,
                                    isDownPayment: termin.isDownPayment
                                }

                                const response = await createPaymentTermin(newValues, token);
                                if (!response.success) {
                                    Swal.fire({
                                        icon: 'error',
                                        title: response.data.message,
                                        confirmButtonText: 'Ok',
                                    })
                                    return;
                                }
                                tempDataTermin.push(newValues)
                                termin.receiptUrls = []; // reset ketika sudah berhasil menambahkan row pertama
                            }
                        }

                        if (tablesData.logs) {
                            var resultData = [response.data.data, ...tablesData.logs]

                            const sortedLeadData = resultData.sort((a, b) => {
                                return new Date(a.date_created).getTime() - new Date(b.date_created).getTime();
                            });

                            sortedLeadData.forEach((eachData: any, index: number) => {
                                if (index < sortedLeadData.length - 1) {
                                    eachData.duration = getDateRangeDuration(sortedLeadData[index].date_created, sortedLeadData[index + 1].date_created);
                                } else {
                                    eachData.duration = "-"
                                }
                            })

                            sortedLeadData.sort((a, b) => {
                                return new Date(b.date_created).getTime() - new Date(a.date_created).getTime();
                            });
                            setTablesData('logs', resultData)
                        }

                        if (user.data.company_id === companyId.juraganMaterial || user.data.company_id === companyId.elgisa) {
                            if ((window.location.pathname).includes('log')) navigate(`/pipelines/${templatePipelineId}`)
                            else mutate(`${API_URL}v2/leads`);
                        }

                        let parsedSourceDate: Date = new Date();
                        if (dateFilter?.typeDateFilter === '3' && 'date_end' in lead) {
                            parsedSourceDate = new Date(lead.date_end);
                        }

                        const hasPendingLog = response.data.data.lead_log_status === 'NEED_APPROVAL';
                        if (tablesData.pipelines && tempDataTermin.length > 0) {
                            const paymentTermins = hasPendingLog ? [] : tempDataTermin;
                            if (!checkIsProgressUTMorUTJTanrise(response.data.data.lead_progress_id, companyId, user)) {
                                setTablesData('pipelines', (tablesData.pipelines.map((item, index) => {
                                    if (item.id === lead.id) {
                                        return {
                                            ...item,
                                            ...convertCustomFields['custom_fields'],
                                            nominal: response.data.data.lead_nominal,
                                            custom_fields: customFieldsValues,
                                            info_custom_fields: convertCustomFields.info_custom_fields,
                                            lead_progress_name: response.data.data.lead_progress_name,
                                            lead_progress_id: response.data.data.lead_progress_id,
                                            lead_progress_progress_type: response.data.data.lead_progress_progress_type,
                                            lead_progress_color: response.data.data.lead_progress_color,
                                            hot_warm_cold_status: response.data.data.lead_progress_progress_type !== 'ONGOING' ? "" : item.hot_warm_cold_status,
                                            lead_logs_count: item.lead_logs_count + 1,
                                            has_pending_log: hasPendingLog,
                                            lead_subprogress_name: response.data.data.lead_sub_progress_name,
                                            date_end: response.data.data.lead_progress_progress_type === 'ONGOING' ? "" : moment().format("YYYY-MM-DD HH:mm:ss"),
                                            date_last_update: moment(response.data.data.updatedAt).utc(true).format('YYYY-MM-DD HH:mm:ss'),
                                            leadProducts: response.data.data.finalLeadProducts.map((product: ListProduct) => ({
                                                ...product,
                                                leadProductId: product.leadProductId,
                                                leadProductHpp: product.leadProductHpp,
                                                leadProductQty: Number(product.leadProductQty),
                                                leadProductPrice: product.leadProductPrice,
                                                leadProductVatPercentage: product.leadProductVatPercentage,
                                                leadProductIsUsingVat: product.leadProductIsUsingVat,
                                                leadProductTotal: product.leadProductTotal,
                                                productUnits: product.productUnits?.map((unit: any) => ({
                                                    convertionToPieces: unit.convertionToPieces,
                                                    unit: {
                                                        id: unit.id,
                                                        name: unit.name,
                                                        alias: unit.alias,
                                                    }
                                                }))
                                            })),
                                            productsAndUnits: response.data.data.finalLeadProducts.map((product: ListProduct) => product.leadProductName),
                                            paymentTermins: paymentTermins,
                                            ...(response.data.data.leadLabels?.length ? { labels: response.data.data.leadLabels } : {})
                                        }
                                    } else {
                                        return item
                                    }
                                })));
                            } else {
                                setFetchCounter(fetchCounter + 1)
                                setTablesData('pipelinesAbandoned', (tablesData.pipelinesAbandoned?.filter((data) => data.id !== lead.id)))
                            }
                        } else if (tablesData.pipelines) {
                            if (!checkIsProgressUTMorUTJTanrise(response.data.data.lead_progress_id, companyId, user)) {
                                setTablesData('pipelines', (tablesData.pipelines.map(item => {
                                    if (item.id === lead.id) {
                                        return {
                                            ...item,
                                            ...convertCustomFields['custom_fields'],
                                            custom_fields: customFieldsValues,
                                            info_custom_fields: convertCustomFields.info_custom_fields,
                                            nominal: response.data.data.lead_nominal,
                                            lead_progress_name: response.data.data.lead_progress_name,
                                            lead_progress_id: response.data.data.lead_progress_id,
                                            lead_progress_progress_type: response.data.data.lead_progress_progress_type,
                                            lead_progress_color: response.data.data.lead_progress_color,
                                            hot_warm_cold_status: response.data.data.lead_progress_progress_type !== 'ONGOING' ? "" : item.hot_warm_cold_status,
                                            lead_logs_count: item.lead_logs_count + 1,
                                            has_pending_log: hasPendingLog,
                                            lead_subprogress_name: response.data.data.lead_sub_progress_name,
                                            date_end: response.data.data.lead_progress_progress_type === 'ONGOING' ? "" : moment().format("YYYY-MM-DD HH:mm:ss"),
                                            date_last_update: moment(response.data.data.updatedAt).utc(true).format('YYYY-MM-DD HH:mm:ss'),
                                            leadProducts: response.data.data.finalLeadProducts.map((product: ListProduct) => ({
                                                ...product,
                                                leadProductId: product.leadProductId,
                                                leadProductHpp: product.leadProductHpp,
                                                leadProductQty: Number(product.leadProductQty),
                                                leadProductPrice: product.leadProductPrice,
                                                leadProductDiscount: product.leadProductDiscount,
                                                leadProductVatPercentage: product.leadProductVatPercentage,
                                                leadProductIsUsingVat: product.leadProductIsUsingVat,
                                                leadProductTotal: product.leadProductTotal,
                                                leadProductVatNominal: product.leadProductVatNominal,
                                                productUnits: product.productUnits?.map((unit: any) => ({
                                                    convertionToPieces: unit.convertionToPieces,
                                                    unit: {
                                                        id: unit.id,
                                                        name: unit.name,
                                                        alias: unit.alias,
                                                    }
                                                }))
                                            })),
                                            productsAndUnits: response.data.data.finalLeadProducts.map((product: ListProduct) => product.leadProductName),
                                            ...(response.data.data.leadLabels?.length ? { labels: response.data.data.leadLabels } : {})
                                        }
                                    } else {
                                        return item
                                    }
                                })));
                            } else {
                                setTablesData('pipelinesAbandoned', (tablesData.pipelinesAbandoned?.filter((data) => data.id !== lead.id)))
                                setFetchCounter(fetchCounter + 1)
                            }
                        } else {
                            if (response.data.data.lead_id === lead.id && window.location.pathname !== "/chat") {
                                setLead({
                                    ...lead,
                                    lead_progress_name: response.data.data.lead_progress_name,
                                    lead_progress_id: response.data.data.lead_progress_id,
                                    lead_progress_progress_type: response.data.data.lead_progress_progress_type,
                                    lead_progress_color: response.data.data.lead_progress_color,
                                    lead_subprogress_name: response.data.data.lead_sub_progress_name,
                                })
                            }
                        }
                        mutate(`${API_URL}v2/leads`, undefined, { revalidate: true })

                        if (window.location.pathname === "/chat") {
                            mutate(`${API_URL}v2/chat/condiments`, undefined, { revalidate: true })

                            if (chatSelectedPipeline) {
                                mutate(`${API_URL}lead_logs/?lead_id=${chatSelectedPipeline.id}`, undefined, { revalidate: true })
                                mutate(`${API_URL}v2/lead/${chatSelectedPipeline.id}`)
                            }
                        }

                        // --------------------------- Invoice PReview  ---------------------------
                        if (hasInvoiceSettings) {
                            try {
                                const getInvoiceSetting = await getInvoiceGeneratedByLatest(token, values.progress, lead.id);
                                const masterLogInvoiceUrl = `${API_URL}invoices/generated/list?leadId=${lead?.id}`
                                mutate(masterLogInvoiceUrl, undefined, { revalidate: true })
                                if (!hasPendingLog) {
                                    Swal.fire({
                                        icon: "success",
                                        title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                                        text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" }),
                                        heightAuto: false,
                                        willClose: () => {
                                            if (!hasInvoiceSettings) {
                                                // Jika tidak ada data, lakukan navigasi
                                                handleModalClose(true)
                                                if (window.location.pathname !== "/chat") {
                                                    navigate(`/pipelines/${templatePipelineId}`);
                                                }
                                            }
                                        },
                                        showCancelButton: !0,
                                        buttonsStyling: !1,
                                        customClass: {
                                            confirmButton: "btn btn-primary",
                                            cancelButton: "btn btn-active-light me-3",
                                        },
                                        reverseButtons: true,
                                        cancelButtonText: intl.formatMessage({ id: "FORM.ACTION.CLOSE" }),
                                        confirmButtonText: intl.formatMessage({ id: "INVOICE.LABEL.VIEW_INVOICE" }),
                                    }).then(async (result) => {
                                        if (result.isConfirmed && stepForm === 0) {
                                            setSelectInvoice(getInvoiceSetting.data.data);
                                            setStepForm(1);
                                        } else {
                                            handleModalClose(true)
                                            if (window.location.pathname !== "/chat") {
                                                navigate(`/pipelines/${templatePipelineId}`);
                                            }
                                        }
                                    });
                                    setModalBtnLoading(false);
                                } else {
                                    Swal.fire({
                                        icon: "success",
                                        title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                                        text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" }),
                                        heightAuto: false,
                                        willClose: () => {
                                            // Jika tidak ada data, lakukan navigasi
                                            if (window.location.pathname !== "/chat") {
                                                navigate(`/pipelines/${templatePipelineId}`);
                                            }
                                        },
                                        confirmButtonText: 'Ok'
                                    }).then(async (result) => {
                                        if (result.isConfirmed && stepForm === 0) {
                                            setModalBtnLoading(false);
                                        }
                                    });
                                    setShowModal(false);
                                }
                            } catch (error: any) {
                                if (!hasInvoiceSettings) {
                                    Swal.fire({
                                        icon: "success",
                                        title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                                        text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" }),
                                        heightAuto: false,
                                        willClose: () => {
                                            // Jika tidak ada data, lakukan navigasi
                                            if (window.location.pathname !== "/chat") {
                                                navigate(`/pipelines/${templatePipelineId}`);
                                            }
                                        },
                                        confirmButtonText: 'Ok'
                                    }).then(async (result) => {
                                        if (result.isConfirmed && stepForm === 0) {
                                            setModalBtnLoading(false);
                                        }
                                    });
                                    setShowModal(false);

                                    return void 0
                                }

                                Swal.fire({
                                    icon: 'error',
                                    title: error?.response?.data?.message || 'Failed to add log',
                                    confirmButtonText: 'Ok',
                                });
                            }
                        } else {
                            Swal.fire({
                                icon: "success",
                                title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                                text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" }),
                                heightAuto: false,
                                willClose: () => {
                                    // Jika tidak ada data, lakukan navigasi
                                    if (window.location.pathname !== "/chat") {
                                        navigate(`/pipelines/${templatePipelineId}`);
                                    }
                                },
                                confirmButtonText: 'Ok'
                            }).then(async (result) => {
                                if (result.isConfirmed && stepForm === 0) {
                                    setModalBtnLoading(false);
                                }
                            });
                            setShowModal(false);

                            return void 0
                        }
                    }
                } catch (error: any) {
                    setModalBtnLoading(false)
                    Swal.fire({
                        icon: 'error',
                        title: error?.response?.data?.message || 'Failed to add log',
                        confirmButtonText: 'Ok',
                        heightAuto: false,
                    })
                } finally {
                    setProgress(undefined)
                    setIsCardDragging(false)
                    setCurrentDraggedPipelineCard(undefined)
                    const modalChatLogs = document.getElementById('chat-logs-modal')

                    if (modalChatLogs) {
                        const modalInstance = Modal.getInstance(modalChatLogs)
                        modalInstance?.show()
                    }
                }
            } else if (typeLog === 'log-lead-temp') {
                const descriptionWithLinks = convertUrlsToLinks(values.description);
                const processDescription = await processDescriptionImages(descriptionWithLinks, token);
                if (typeAction === 'add') {
                    const formatPipelineName = selectedPipelineLogTemp ? `${selectedPipelineLogTemp.merchant_name} / ${selectedPipelineLogTemp.owner_name} / ${moment(selectedPipelineLogTemp.date_start).format("DD MMM YYYY")} / ${currencyFormatter(selectedPipelineLogTemp.nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true })}` : 'Unknown'
                    const data = {
                        id: uuidv4(),
                        leadId: lead.id,
                        pipelineName: formatPipelineName,
                        progressName: progressesData.find((p) => p.value === formik.values.progress)?.label || '',
                        subProgressName: subProgressesData.find((p) => p.value === formik.values.subProgress)?.label || '',
                        description: processDescription,
                        leadProgressId: formik.values.progress,
                        subProgressId: formik.values.subProgress,
                        leadProgressColor: progresses.find((p: any) => p.id === formik.values.progress)?.color || '',
                        attachments: values.attachment || [],
                        leadProducts: listProducts,
                        termins: tempPaymentTermin as unknown as PaymentTermin[],
                        customFields: customFieldsValues as unknown as CustomFields,
                        createdAt: new Date().toISOString(),
                        labelIds: formik.values.labels,
                        labelNames: labelsData.filter((option: any) => formik.values.labels.includes(option.value)).map(option => option.label)
                    }
                    const response = await addLogLeadByTemplatePipelineId(templatePipelineId || '', data)
                    if (response) {
                        Swal.fire({
                            icon: 'success',
                            title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                            text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.ADD_SUCCESS" }),
                            heightAuto: false,
                        })
                        formik.resetForm()
                        setModalBtnLoading(false)
                        setShowModal(false)
                        setSelectedPipelineLogTemp(null)
                    }
                } else if (typeAction === 'edit') {
                    const formatPipelineName = lead ? `${lead.merchant_name} / ${((lead as Pipeline).owner_name)} / ${moment((lead as Pipeline).date_start).format("DD MMM YYYY")} / ${currencyFormatter((lead as Pipeline).nominal, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true })}` : 'Unknown'
                    const data = {
                        id: logLeadTemp?.id ?? '',
                        leadId: lead.id,
                        pipelineName: formatPipelineName,
                        progressName: progressesData.find((p) => p.value === formik.values.progress)?.label || '',
                        subProgressName: subProgressesData.find((p) => p.value === formik.values.subProgress)?.label || '',
                        description: processDescription,
                        leadProgressId: formik.values.progress,
                        subProgressId: formik.values.subProgress,
                        leadProgressColor: progresses.find((p: any) => p.id === formik.values.progress)?.color || '',
                        attachments: values.attachment || [],
                        leadProducts: listProducts,
                        termins: tempPaymentTermin as unknown as PaymentTermin[],
                        customFields: customFieldsValues as unknown as CustomFields,
                        createdAt: new Date().toISOString(),
                        labelIds: formik.values.labels,
                        labelNames: labelsData.filter((option: any) => formik.values.labels.includes(option.value)).map(option => option.label)
                    }

                    const response = await updateLogLeadTempByIdLog(logLeadTemp?.id || '', data)
                    if (response) {
                        Swal.fire({
                            icon: 'success',
                            title: intl.formatMessage({ id: "ALERT.TITLE.SUCCESS" }),
                            text: 'Log ' + intl.formatMessage({ id: "FORM.VALIDATION.UPDATE_SUCCESS" }),
                            heightAuto: false,
                        })

                        formik.resetForm()
                        setModalBtnLoading(false)
                        setShowModal(false)
                        setSelectedPipelineLogTemp(null)
                    } else {
                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: 'Failed to update log. Please try again.',
                            heightAuto: false,
                        })
                        setModalBtnLoading(false)
                    }
                }
            }
        }
    });

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const { data: customFieldLog, isLoading: customFieldLogLoading } = useSWR(
        formik.values.progress ?
            `${API_URL}lead_logs/custom-field?lead_id=${lead.id}&progress_id=${formik.values.progress}`
            : null,
        fetcher
    );

    useEffect(() => {
        if (!logLeadTemp) return

        formik.setFieldValue('progress', logLeadTemp.leadProgressId)
        if (progressesData.length > 0) {
            const selectProgress = progressesData.find((p) => p.value === logLeadTemp.leadProgressId) as unknown as Progress
            setSelectedProgress(selectProgress)
        }

        if (progressesData.length > 0) {
            const typeProgress = progressesData.find((p) => p.value === logLeadTemp.leadProgressId)
            setTypeProgress(typeProgress?.typeProgress || '')
            setIsSplitTableTermin(true)
        } else {
            setTypeProgress('')
            setIsSplitTableTermin(false)
        }

        if (logLeadTemp.leadProducts.length > 0) {
            setListProducts(logLeadTemp.leadProducts)
        } else {
            setListProducts([])
        }
    }, [logLeadTemp, progressesData, formik.values])

    useEffect(() => {
        if (!logLeadTemp) return

        if (logLeadTemp?.termins.length > 0) {
            const remainingAmountLogLeadTemp = logLeadTemp.termins.reduce((acc, curr) => acc + curr.nominal, 0)
            setRemainingAmount(remainingAmount - remainingAmountLogLeadTemp)

            setTempPaymentTermin(logLeadTemp.termins as unknown as TempPaymentTermin[])
            setToggleCheckbox(false)
        } else {
            setTempPaymentTermin([])
            setToggleCheckbox(true)
        }
    }, [logLeadTemp])

    useEffect(() => {
        if (!(lead as unknown as LogLeadTemp)?.termins) return

        if ((lead as unknown as LogLeadTemp)?.termins.length > 0) {
            const remainingAmountLogLeadTemp = (lead as unknown as LogLeadTemp)?.termins.reduce((acc, curr) => acc + curr.nominal, 0)
            setRemainingAmount(remainingAmount - remainingAmountLogLeadTemp)

            setTempPaymentTermin((lead as unknown as LogLeadTemp)?.termins as unknown as TempPaymentTermin[])
            setToggleCheckbox(false)
        } else {
            setTempPaymentTermin([])
            setToggleCheckbox(true)
        }
    }, [lead])

    useEffect(() => {
        if (tempPaymentTermin && tempPaymentTermin.length > 0 && toggleCheckbox) { // untuk reset nominal pembayaran jika di uncheck
            setTempPaymentTermin([])
            setRemainingAmount(lead.nominal)
        }
    }, [tempPaymentTermin, toggleCheckbox])

    useEffect(() => {
        if (customFieldLog) {
            const formSchema = Object.keys(customFieldLog).reduce((obj: any, item: string) => {
                const field = customFieldLog[item];
                const isRequiredMessage = intl.formatMessage(
                    { id: "FORM.VALIDATION.FIELD_REQUIRED" },
                    { title: field.name }
                );
                const isValidUrlMessage = intl.formatMessage({ id: "FORM.VALIDATION.MUST_LINK" });
                if (field.type === 'multiple' || field.type === 'multipleOption' || field.type === 'images' || field.type === 'files' || field.type === 'videos' || field.type === 'merchant' || field.type === 'user' || field.type === 'meeting' || field.type === 'product') {
                    obj[item] = field.required
                        ? Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable()
                        : Yup.array().notRequired().nullable();
                } else if (field.type === 'date') {
                    obj[item] = field.required
                        ? Yup.string().required(isRequiredMessage).nullable()
                        : Yup.string().notRequired().nullable();
                } else if (field.type === 'link') {
                    obj[item] = field.required
                        ? Yup.string().nullable().required(isRequiredMessage).test('is-required', isValidUrlMessage, function (value) {
                            return !value || isValidUrl(value);
                        })
                        : Yup.string().nullable().test('is-required', isValidUrlMessage, function (value) {
                            return !value || isValidUrl(value);
                        });
                } else if (field.type === 'serial') {
                    obj[item] = Yup.array().notRequired().nullable();
                } else if (field.type === 'user' || field.type === 'merchant' || field.type === 'pipeline') {
                    obj[item] = field.required
                        ? Yup.mixed().required(isRequiredMessage).nullable()
                        : Yup.mixed().notRequired().nullable();
                } else if (field.type === 'dateTimeRange') {
                    if (field.required) {
                        obj[item] = Yup.array().min(1, isRequiredMessage).required(isRequiredMessage).nullable();
                    } else {
                        obj[item] = Yup.array().notRequired().nullable();
                    }
                } else {
                    obj[item] = field.required
                        ? Yup.string().required(isRequiredMessage).nullable()
                        : Yup.string().notRequired().nullable();
                }
                return obj;
            }, {});
            // Create complete validation schema
            const newValidationSchema = Yup.object().shape({
                progress: Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.MENU.PROGRESSES" }) })),
                subProgress: (subProgressesData.length > 0) ? Yup.string().required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.SUBPROGRESS" }) })) : Yup.string().notRequired().nullable(),
                description: Yup.string()
                    .required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DESCRIPTION" }) }))
                    .test('is-not-empty', intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.DESCRIPTION" }) }), function (value: string | undefined) {
                        if (!value) return false;
                        const cleanContent = sanitizeTagHtml(value).trim();
                        return cleanContent.length > 0;
                    })
                    .test('image-size', 'One or more images exceed the maximum size of 5MB', function (value: string | undefined) {
                        if (!value) return true;

                        const images = value.match(/<img[^>]+src="(data:image\/[^;]+;base64,[^"]+)"/g);
                        if (!images) return true;

                        for (const img of images) {
                            const match = img.match(/src="(data:image\/[^;]+;base64,[^"]+)"/);
                            if (match && match[1]) {
                                const base64 = match[1];
                                const sizeInBytes = atob(base64.split(',')[1]).length;
                                if (sizeInBytes > MAX_FILE_SIZE) return false;
                            }
                        }
                        return true;
                    }),
                attachment: Yup.mixed().when('isRequiredAttachment', {
                    is: true,
                    then: Yup.mixed().test('is-non-empty-array', intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.ATTACHMENT" }) }), function (value) {
                        return Array.isArray(value) && value.length > 0;
                    }),
                    otherwise: Yup.mixed().nullable().test('is-valid-attachment', 'Invalid attachment value', function (value) {
                        return value === null || (Array.isArray(value) && value.length >= 0);
                    })
                }),
                isRequiredAttachment: Yup.boolean(),
                labels: (labelsData.length > 0) ? Yup.array().min(1, intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.LABELS" }) })).required(intl.formatMessage({ id: "FORM.VALIDATION.FIELD_REQUIRED" }, { title: intl.formatMessage({ id: "FORM.LABEL.LABELS" }) })) : Yup.array().notRequired(),
                ...formSchema
            });
            setValidationSchema(newValidationSchema);
        }
    }, [customFieldLog, subProgressesData, intl]);

    useEffect(() => {
        if (tempPaymentTermin && tempPaymentTermin.length > 0) {
            const latestPayment = tempPaymentTermin[tempPaymentTermin.length - 1];
            const latestDueDate = latestPayment.progress === 'PAID' || !latestPayment.dateDue ? null : new Date(latestPayment.dateDue);
            latestDueDate && latestDueDate.setHours(0, 0, 0, 0);
            setShouldDate(latestDueDate);
        } else {
            setShouldDate(null);
        }
    }, [tempPaymentTermin]);

    // Function untuk memvalidasi tanggal
    const isDateDisabled = (date: Date) => {
        if (!date) return false;

        const checkDate = new Date(date);
        checkDate.setHours(0, 0, 0, 0);

        if (shouldDate) {
            return checkDate <= shouldDate;
        } else {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return checkDate < today;
        }
    };

    useEffect(() => { // reset tanggal ketika terjadi perubahan togglePayment
        if (!formik.values.terminForm.togglePayment) {
            formik.setFieldValue('terminForm.dateDue', '')
        } else if (formik.values.terminForm.togglePayment) {
            formik.setFieldValue('terminForm.datePaid', '')
        }

        if (terminErrors.dateDue && !formik.values.terminForm.togglePayment) {
            setTerminErrors({ ...terminErrors, dateDue: '' })
        } else if (terminErrors.datePaid && formik.values.terminForm.togglePayment) {
            setTerminErrors({ ...terminErrors, datePaid: '' })
        }
    }, [formik.values.terminForm.togglePayment])

    useEffect(() => {
        formik.setFieldValue('terminForm.nominal', '')
    }, [formik.values.terminForm.inputType])

    const isShowTableProduct = (data: Progress) => {
        const checkValue = Object.values(data.editLeadProductAccess).some(val =>
            typeof val === 'object'
                ? Object.values(val).some(innerVal => innerVal === true)
                : val === true
        );

        return checkValue
    }

    const insertImageToEditor = useCallback((base64: string) => {
        const editor = quillRef.current?.getEditor();
        if (editor) {
            const range = editor.getSelection();
            if (range) {
                editor.insertEmbed(range.index, 'image', base64, 'user');
            }
        }
    }, []);

    const handlePaste = useCallback(async (event: ClipboardEvent) => {
        const items = event.clipboardData?.items;

        if (items) {
            const itemsArray = Array.from(items);
            const fileItems = itemsArray.filter(item => item.kind === 'file');
            const textItems = itemsArray.filter(item => item.kind === 'string');

            if (fileItems.length > 0) {
                const filePromises = fileItems.map((file) => {
                    return new Promise<File | null>(async (resolve, reject) => {
                        const blob = file.getAsFile();
                        if (blob) {
                            try {
                                if (file.type.startsWith('image/')) {
                                    event.preventDefault();
                                    if (blob.size > MAX_FILE_SIZE) {
                                        Swal.fire({
                                            icon: 'error',
                                            title: "Image size exceeds 5MB limit",
                                            text: "Please use an image smaller than 5MB.",
                                            confirmButtonText: 'Ok',
                                        });
                                        resolve(null);
                                    } else {
                                        const base64 = await getBase64(blob);
                                        insertImageToEditor(base64);
                                        resolve(null);
                                    }
                                } else {
                                    event.preventDefault();
                                    resolve(blob);
                                }
                            } catch (error) {
                                console.error('Error processing file:', error)
                                reject(error)
                            }
                        } else {
                            resolve(null);
                        }
                    })
                });

                try {
                    const results = await Promise.all(filePromises);
                    const validFiles = results.filter((file): file is File => file !== null);
                    const currentAttachments = formik.values.attachment || [];
                    formik.setFieldValue('attachment', [...currentAttachments, ...validFiles]);
                } catch (error) {
                    console.error('Error processing pasted items:', error);
                    Swal.fire({
                        icon: 'error',
                        title: "Error ketika copy file",
                        confirmButtonText: 'Ok',
                    });
                }
            } else if (textItems.length > 0) {
                textItems[0].getAsString((text) => {
                    const editor = quillRef.current?.getEditor();
                    if (editor) {
                        const range = editor.getSelection();
                        if (range) {
                            editor.insertText(range.index, text);
                        }
                    }
                });
            }
        }
    }, [formik, getBase64, insertImageToEditor]);

    document.querySelectorAll('.ql-tooltip.ql-editing input[type="text"]').forEach(input => {
        if (!input.classList.contains('txt-log')) {
            input.classList.add('txt-log');
        }
    });

    const handleImageClick = useCallback((e: MouseEvent) => {
        const target = e.target as HTMLElement;
        if (target.classList.contains('image-link')) {
            e.preventDefault();
            const imageUrl = target.getAttribute('data-image-url');
            const imageIndex = target.getAttribute('data-image-index');
            if (imageUrl && imageIndex) {
                setModalImage({ show: true, url: imageUrl, title: `Gambar ${imageIndex}` });
            }
        }
    }, []);

    const handleNominalPembayaranChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Hapus semua karakter non-digit (termasuk titik)
        const rawValue = e.target.value ?? '0'

        const currencyFormatterValidation = currencyFormatterPreventPropagation(rawValue);

        if (currencyFormatterValidation.hasTrailingMultipleDot) {
            return void 0
        }
        if (currencyFormatterValidation.hasTrailingDot || currencyFormatterValidation.hasTrailingDotZero) {
            return formik.setFieldValue('terminForm.nominal', e.target.value);;
        }

        // Check if input type is percentage and value is greater than 100
        if (formik.values.terminForm.inputType === 'percentage') {
            const numValue = parseInt(rawValue, 10);
            if (numValue > 100) {
                setTerminErrors({ nominal: intl.formatMessage({ id: "FORM.LABEL.PERCENTAGE_MAX" }) });
                return;
            }
        }

        // Format angka dengan pemisah ribuan
        const formattedValue = currencyFormatter(e.target.value, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode);
        formik.setFieldValue('terminForm.nominal', formattedValue);
        // Clear error when valid input is entered
        if (terminErrors.nominal) {
            setTerminErrors({ ...terminErrors, nominal: '' });
        }
    };

    const handleVATTerminChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        // Hapus semua karakter non-digit (termasuk titik)
        const rawValue = e.target.value.replace(/[^\d]/g, '');


        const formattedValue = currencyFormatter(rawValue, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode);
        if (Number(rawValue) > 100) {
            return;
        }
        formik.setFieldValue('terminForm.vatPercentage', formattedValue);
        // Clear error when valid input is entered
        if (terminErrors.vatPercentage) {
            setTerminErrors({ ...terminErrors, vatPercentage: '' });
        }
    };

    useEffect(() => {
        document.addEventListener('click', handleImageClick);
        return () => {
            document.removeEventListener('click', handleImageClick);
        };
    }, [handleImageClick]);

    useEffect(() => {
        document.addEventListener('paste', handlePaste);
        return () => {
            document.removeEventListener('paste', handlePaste);
        };
    }, [handlePaste]);

    const loadSubProgresses = useCallback(async (progressId: string) => {
        if (!progressId) return;
        setIsLoadingSubProgresses(true);
        try {
            const result = await fetchWithToken([`${API_URL}lead_sub_progresses/${progressId}`, token]);
            const subProgressesData = result.map((progress: Progress) => ({
                value: progress.id,
                label: progress.name
            }));
            setSubProgressesData(subProgressesData);
        } catch (error) {
            console.error("Error loading sub-progresses:", error);
        } finally {
            setIsLoadingSubProgresses(false);
        }
    }, [API_URL]);

    const loadLabels = useCallback(async (id: string) => {
        if (!id || labelsData?.length || !(isLabelRequired(id))) return;
        setLabelLoading(true);
        try {
            const result = await fetchWithToken([`${API_URL}labels?usableBy[]=pipeline`, token]);
            const labelsData = result.map((label: Label) => ({
                value: label.id,
                label: label.name
            }));
            setLabelsData(labelsData);
        } catch (error) {
            console.error("Error loading labels:", error);
        } finally {
            setLabelLoading(false);
        }
    }, [API_URL]);

    useEffect(() => {
        // Get the modal element
        const modalElement = modalRef.current;

        // Define the event listener
        const handleModalHidden = () => {
            formik.resetForm()
            fileInputRef.current?.value && (fileInputRef.current.value = "")
            // setLeadProductsData([])
            setListProducts([])
        };

        // Attach the event listener
        modalElement?.addEventListener('hidden.bs.modal', handleModalHidden);

        // Cleanup
        return () => {
            modalElement?.removeEventListener('hidden.bs.modal', handleModalHidden);
        };
    }, [formik]);

    useEffect(() => {
        if (!progressesLoading) {
            const progressesData = progresses.map((progress: Progress) => ({
                value: progress.id,
                label: progress.name,
                isRequiredUpdateProductHpp: progress.isRequiredUpdateProductHpp,
                isRequiredAttachment: progress.isRequiredAttachment,
                typeProgress: progress.progress_type,
                isSplittable: progress.isSplittable,
                editLeadProductAccess: {
                    create: progress.editLeadProductAccess.create,
                    delete: progress.editLeadProductAccess.delete,
                    edit: {
                        price: progress.editLeadProductAccess.edit.price,
                        quantity: progress.editLeadProductAccess.edit.quantity,
                        cogs: progress.editLeadProductAccess.edit.cogs,
                        discount: progress.editLeadProductAccess.edit.discount,
                    }
                },
                approvals: progress?.approvals || []
            }));
            const progressesDataWithoutTypeApproval = progressesData.filter((data: any) => data?.approvals && data?.approvals.length === 0)
            setProgressesData(typeLog === 'log-lead-temp' ? progressesDataWithoutTypeApproval : progressesData)
            if (progress) {

                const getProgress = progressesData.filter((data: any) => data.value === progress)[0]
                formik.setFieldValue('progress', getProgress)
                setDefaultValueProgress(progressesData.filter((data: any) => data.value == progress)[0])

                const option = progressesData.find((opt: any) => opt.value === progress);
                setIsSplitTableTermin(option?.isSplittable || false);
                setTypeProgress(option?.typeProgress || '');

                formik.setFieldValue('progress', option?.value || '');
                formik.setFieldValue('update_product_hpp', option?.isRequiredUpdateProductHpp);
                formik.setFieldValue('isRequiredAttachment', option?.isRequiredAttachment);
                formik.setFieldValue('editLeadProductAccess', option?.editLeadProductAccess);

                // Optionally, trigger onChange
                formik.handleChange({
                    target: { name: "progress", value: option?.value || '' },
                });

                formik.handleChange({
                    target: { name: "update_product_hpp", value: option?.isRequiredUpdateProductHpp },
                });

                formik.handleChange({
                    target: { name: "isRequiredAttachment", value: option?.isRequiredAttachment },
                });

                formik.handleChange({
                    target: { name: "editLeadProductAccess", value: option?.editLeadProductAccess },
                });
            }
        }
    }, [progresses, progress])

    useEffect(() => {
        if (formik.values.progress) {
            loadSubProgresses(formik.values.progress);
            loadLabels(formik.values.progress);
        } else {
            setSubProgressesData([]);
        }
    }, [formik.values.progress, loadSubProgresses, defaultValueProgress]);

    useEffect(() => {
        mutate(`${API_URL}lead_sub_progresses/${formik.values.progress}`)
    }, [formik.values.progress])

    const handlePaymentDate = (date: Date | null, isTogglePayment: boolean) => {
        const filterDate = moment(date).format('YYYY-MM-DD');

        if (date === null && !isTogglePayment) {
            formik.setFieldValue('terminForm.dateDue', '');
        } else if (date === null && isTogglePayment) {
            formik.setFieldValue('terminForm.datePaid', '');
        } else if (date !== null && !isTogglePayment) {
            formik.setFieldValue('terminForm.dateDue', filterDate);
        } else if (date !== null && isTogglePayment) {
            formik.setFieldValue('terminForm.datePaid', filterDate);
        }
    };

    const handleAddPaymentTermin = () => {

        const terminFormValues = {
            nominal: formik.values.terminForm.nominal,
            dateDue: formik.values.terminForm.togglePayment ? '' : formik.values.terminForm.dateDue,
            datePaid: formik.values.terminForm.togglePayment ? formik.values.terminForm.datePaid : '',
            customFields: formik.values.terminForm.customFields,
            progress: formik.values.terminForm.togglePayment ? 'PAID' : 'PENDING',
            receiptUrls: formik.values.terminForm.receiptUrls || null,
            vatPercentage: formik.values.terminForm.vatPercentage,
        };

        const errors = validateTerminForm(terminFormValues, customFieldTermin, formik.values.terminForm.togglePayment);
        setTerminErrors(errors);

        if (Object.keys(errors).length > 0) {
            return;
        }


        let currentPaymentAmount: number = 0;
        if (formik.values.terminForm.inputType === 'nominal') {

            currentPaymentAmount = parseFloat(formik.values.terminForm.nominal.replaceAll(",", ""));
        } else { // percentage
            const percentageValue = parseFloat(formik.values.terminForm.nominal.replaceAll(",", ""));
            const checkLeadNominal = typeof totalNominalPipeline === 'number' ? totalNominalPipeline : parseFloat(parseFormattedCurrency(totalNominalPipeline))
            currentPaymentAmount = selectMultiPipeline.currencyIsRounded ? Math.round((percentageValue / 100) * checkLeadNominal) : (percentageValue / 100) * checkLeadNominal;
        }
        if (currentPaymentAmount === 0) {
            setTerminErrors({ nominal: intl.formatMessage({ id: "FORM.LABEL.PAYMENT_AMOUNT_0" }) });
            return;
        }

        if (currentPaymentAmount > remainingAmount) {
            setTerminErrors({ nominal: intl.formatMessage({ id: "FORM.LABEL.TERMIN_FULLFILLED" }) });
            return;
        }

        let vatPercentage = Number(formik.values.terminForm.vatPercentage.replaceAll(".", "")) ? Number(formik.values.terminForm.vatPercentage) : 0


        let nominalWithVAT = vatPercentage ? selectMultiPipeline.currencyIsRounded ? Math.round(currentPaymentAmount + currentPaymentAmount * vatPercentage / 100) : currentPaymentAmount + currentPaymentAmount * vatPercentage / 100 : currentPaymentAmount

        const checkDateDownPaymentDatePaid = tempPaymentTermin.find((item: TempPaymentTermin) => item.isDownPayment && (item.datePaid || '') > formik.values.terminForm.datePaid)

        if (checkDateDownPaymentDatePaid && formik.values.terminForm.togglePayment) {
            Swal.fire({
                icon: 'error',
                title: intl.formatMessage({ id: 'FORM.VALIDATION.TERMIN_DATE_DOWN_PAYMENT_ERROR_TITLE' }),
                text: intl.formatMessage({ id: 'FORM.VALIDATION.TERMIN_DATE_DOWN_PAYMENT_ERROR' }),
            })
            return
        }
        const checkDateDownPaymentDateDue = tempPaymentTermin.find((item: TempPaymentTermin) => item.isDownPayment && item.dateDue && item.dateDue > formik.values.terminForm.dateDue)

        if (checkDateDownPaymentDateDue && !formik.values.terminForm.togglePayment) {
            Swal.fire({
                icon: 'error',
                title: intl.formatMessage({ id: 'FORM.VALIDATION.TERMIN_DATE_DOWN_PAYMENT_ERROR_TITLE' }),
                text: intl.formatMessage({ id: 'FORM.VALIDATION.TERMIN_DATE_DOWN_PAYMENT_ERROR' }),
            })
            return
        }
        // Add new termin
        setTempPaymentTermin(prevState => [
            ...prevState,
            {
                nominal: roundDecimalToTwo(currentPaymentAmount),
                dateDue: formik.values.terminForm.togglePayment ? null : formik.values.terminForm.dateDue,
                customFields: formik.values.terminForm.customFields,
                progress: formik.values.terminForm.togglePayment ? 'PAID' : 'PENDING',
                datePaid: formik.values.terminForm.togglePayment ? formik.values.terminForm.datePaid : null,
                receiptUrls: formik.values.terminForm.receiptUrls || [],
                vatPercentage: Number(formik.values.terminForm.vatPercentage),
                total: selectMultiPipeline.currencyIsRounded ? Math.round(nominalWithVAT) : roundDecimalToTwo(nominalWithVAT),
                isDownPayment: formik.values.terminForm.isPaymentDP ?? false,
                inputType: formik.values.terminForm.inputType
            }
        ]);

        setRemainingAmount(prevAmount => roundDecimalToTwo(prevAmount - currentPaymentAmount));

        formik.setFieldValue('terminForm', {
            inputType: formik.values.terminForm.inputType,
            nominal: '',
            dateDue: '',
            datePaid: '',
            togglePayment: false,
            customFields: {},
            vatPercentage: "",
        });

        refArray.current.forEach(ref => {
            if (ref) {
                ref.value = '';
            }
        });

        setTerminErrors({});
    };

    // Delete Item
    const handleDeleteItem = (index: number) => {
        setTempPaymentTermin(prevTermins => {
            const newTermins = [...prevTermins];
            const deletedItem = newTermins.splice(index, 1)[0];
            setRemainingAmount(prevAmount => selectMultiPipeline.currencyIsRounded ? Math.round(prevAmount + deletedItem.nominal) : roundDecimalToTwo(prevAmount + deletedItem.nominal));
            return newTermins;
        });
    };

    const suggestPeople = async (searchTerm: string) => {
        const allPeople = await userMentionData.length > 0 ? userMentionData : [];

        return allPeople.filter((person: any) =>
            person.username.toLowerCase().includes(searchTerm.toLowerCase())
        );
    }

    useEffect(() => {
        const progressOption = progressesData.find((p) => p.value === progress)
        setIsSplitTableTermin(progressOption?.isSplittable || false)
        setTypeProgress(progressOption?.typeProgress || '')
        formik.handleChange({
            target: {
                name: "progress",
                value: progressOption?.value || ''
            }
        });

        formik.handleChange({
            target: {
                name: "update_product_hpp",
                value: progressOption?.isRequiredUpdateProductHpp
            }
        });

        formik.handleChange({
            target: {
                name: "isRequiredAttachment",
                value: progressOption?.isRequiredAttachment
            }
        });

        formik.handleChange({
            target: {
                name: "editLeadProductAccess",
                value: progressOption?.editLeadProductAccess
            }
        });

    }, [progress, progressesData])

    // List Products
    useEffect(() => {
        if (typeAction === 'edit' && typeLog === 'log-lead-temp') {
            return;
        }

        const getProducts = (lead?.leadProducts || []).map((product: any) => {
            const total = calculateProductTotal(
                product.leadProductQty,
                Number(product.leadProductPrice),
                Number(product?.leadProductDiscount ?? 0),
                product.leadProductDiscountType || 'NOMINAL',
                product.leadProductVatPercentage ?? 0,
                selectMultiPipeline,
                product.leadProductIsPriceIncludeVat ?? false
            );

            return {
                ...product,
                leadProductLabels: product.productLabels?.map((label: Label) => ({ label })) || [],
                edit: false,
                hpp: product.leadProductHpp,
                leadProductTotal: total,
                id: product.productId
            };
        });

        setListProducts(getProducts);
    }, [lead, selectedProgress, typeAction, typeLog]);

    // ubah remaining amount ketika terdaapt nominal product yang berubah di list product
    useEffect(() => {
        if (listProducts.length > 0) {
            const totalNominal = listProducts.reduce((acc, product) => acc + changeValueIfStringIntoNumber(product.leadProductTotal), 0)
            const tempPaymentTerminNominal = tempPaymentTermin.reduce((acc, termin) => acc + changeValueIfStringIntoNumber(termin.nominal), 0)
            if (totalNominal < tempPaymentTerminNominal && tempPaymentTermin.length > 0) {
                setRemainingAmount(totalNominal);
                setTempPaymentTermin([]);
            } else {
                setRemainingAmount(totalNominal - tempPaymentTerminNominal)
            }
        } else {
            setRemainingAmount(0)
        }
    }, [listProducts, toggleCheckbox, tempPaymentTermin])

    const handleModalClose = (isSkipAlert: boolean = false) => {
        const resetAllState = () => {
            setSelectInvoice(null)
            setStepForm(0);
            setShowModal(false);
            formik.resetForm();
        }
        if (isSkipAlert) {
            resetAllState()
            return void 0
        }
        Swal.fire({
            title: intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
            text: intl.formatMessage({ id: 'FORM.VALIDATION.DESC_CANCEL' }),
            icon: 'warning',
            showCancelButton: !0,
            buttonsStyling: !1,
            customClass: {
                confirmButton: "btn btn-danger",
                cancelButton: "btn btn-active-light me-3",
            },
            reverseButtons: true,
            heightAuto: false,
            confirmButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.YES' }) + ", " + intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
            cancelButtonText: intl.formatMessage({ id: 'FORM.CONFIRMATION.NO' }),
        }).then((result) => {
            if (result.isConfirmed) {
                resetAllState()
            }
        });
    }

    const showCheckboxPaidOffTermin = () => {
        const hasKeyTermins = (lead as unknown as LogLeadTemp)?.termins
        if (typeLog === 'log-lead-temp' && typeAction === 'add' && hasKeyTermins && hasKeyTermins.length > 0) {
            return false
        } else if (typeLog === 'log-lead-temp' && typeAction === 'edit' && hasKeyTermins && (logLeadTemp?.termins?.length ?? 0) > 0) {
            return true
        } else {
            return true
        }
    }

    const handleAlertAddProduct = (desc: string) => {
        Swal.fire({
            title: 'Warning',
            text: intl.formatMessage({ id: 'ALERT.DESC.RESET_PAYMENT_TERM' }, { title: desc }),
            icon: 'warning',
            confirmButtonText: 'OK',
            showCancelButton: true,
            cancelButtonText: 'Cancel',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            reverseButtons: true,
            allowOutsideClick: false,
            allowEscapeKey: false,
        }).then((result) => {
            if (result.isConfirmed) {
                setTempPaymentTermin([])
                setShowModalAddProduct(true)
                setTypeActionProduct('add')
                setProductTemp({} as ListProduct)
            }
        })
    }

    useModalEffectResponsive({
        modalIdPrimary: 'tambah-log-modal',
        modalIdSecondary: 'modal-add-product-pipeline',
        showModalSeconday: showModalAddProduct,
        setShowModalSecondary: setShowModalAddProduct
    })

    return (
        <>
            {/* {
                ((window.location.pathname).includes('log') && showAddLogButton) &&
                <button
                    type="button"
                    className="btn btn-primary"
                    onClick={() => {
                        setStepForm(0);
                        setShowModal(true);
                    }}
                >
                    {intl.formatMessage({ id: "FORM.ACTION.ADD" })} {intl.formatMessage({ id: "FORM.MENU.LOGS" })}
                </button>
            } */}

            <div className={`modal fade ${showModalAddProduct || showMasterLogModal ? 'hide' : 'show'}`} tabIndex={-1} id="tambah-log-modal" ref={modalRef} style={{ zIndex: showModalAddProduct ? 0 : 9999 }}>
                <div className="modal-dialog modal-dialog-centered" style={{ maxWidth: "1250px" }}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {stepForm === 0
                                    ? `${intl.formatMessage({ id: "FORM.ACTION.ADD" })} ${intl.formatMessage({ id: "FORM.MENU.LOGS" })} ${lead.merchant_name} ${!(window.location.pathname).includes('chat') ? showSerial(lead as Pipeline, keyCustomfield) : ''}`
                                    : `${intl.formatMessage({ id: 'INVOICE.PANEL.LOG_PREVIEW_PAGES' })} ${selectInvoice?.name ?? ''}`
                                }
                            </h5>
                            <div
                                className="btn btn-active-light-primary btn-icon btn-sm ms-2"
                                onClick={() => handleModalClose()}
                            >
                                <KTSVG
                                    path="/media/icons/duotune/arrows/arr061.svg"
                                    className="svg-icon svg-icon-2x"
                                />
                            </div>
                        </div>
                        <div className="modal-body" style={{ padding: '0px', minHeight: '400px' }}>
                            <ImageModal
                                show={modalImage.show}
                                onHide={() => setModalImage({ ...modalImage, show: false })}
                                imageUrl={modalImage.url}
                                title={modalImage.title}
                            />
                            {stepForm === 0 && (
                                <form onSubmit={formik.handleSubmit} noValidate>
                                    <div className="modal-body">
                                        {formik.status && (
                                            <div className='alert alert-danger mb-lg-15'>
                                                <div className='alert-text font-weight-bold'>{formik.status}</div>
                                            </div>
                                        )}
                                        <div className="d-flex gap-4 mb-2">
                                            <label className='form-label m-0 text-dark fs-6 fw-bolder required'>{intl.formatMessage({ id: "FORM.MENU.PROGRESSES" })}</label>
                                            {(settings.feature_invoice && invoiceSettings && typeLog === 'default' && !invoiceSettingsLoading && invoiceSettings.length > 0 && invoiceSettings.some((inv: InvoiceMultiPageSetting) => { return inv.progress?.id === formik.values.progress })) &&
                                                <Badge bg="success">{intl.formatMessage({ id: "INVOICE.LABEL.SEND_INVOICE" })}</Badge>
                                            }
                                        </div>
                                        <div className="input-group mb-3">
                                            <VirtualizedSelect
                                                isDisabled={progress !== undefined || (typeAction === 'edit' && typeLog === 'log-lead-temp')}
                                                className="w-100"
                                                name="progress"
                                                placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.MENU.PROGRESSES" })}`}
                                                options={progressesData}
                                                value={
                                                    progressesData.find(option => {
                                                        return option.value === formik.values.progress
                                                    }) || null
                                                }
                                                onChange={(option) => {
                                                    setSelectedProgress(option)
                                                    setIsSplitTableTermin(option?.isSplittable || false)
                                                    setTypeProgress(option?.typeProgress || '')
                                                    setToggleCheckbox(true)
                                                    formik.setFieldValue('subProgress', ''); // Menetapkan nilai subProgress ke kosong saat progress berubah
                                                    formik.handleChange({
                                                        target: {
                                                            name: "progress",
                                                            value: option?.value || ''
                                                        }
                                                    });

                                                    formik.handleChange({
                                                        target: {
                                                            name: "update_product_hpp",
                                                            value: option?.isRequiredUpdateProductHpp
                                                        }
                                                    });

                                                    formik.handleChange({
                                                        target: {
                                                            name: "isRequiredAttachment",
                                                            value: option?.isRequiredAttachment
                                                        }
                                                    });

                                                    formik.handleChange({
                                                        target: {
                                                            name: "editLeadProductAccess",
                                                            value: option?.editLeadProductAccess
                                                        }
                                                    });

                                                    if (settings.feature_invoice && invoiceSettings && !invoiceSettingsLoading && typeLog === 'default' && invoiceSettings.length > 0 && invoiceSettings.some((inv: InvoiceMultiPageSetting) => { return inv.progress?.id === option.value })
                                                    ) {
                                                        setHasInvoiceSettings(true)
                                                    } else {
                                                        setHasInvoiceSettings(false)
                                                    }
                                                }}
                                                onBlur={
                                                    () => formik.values.progress === "" && formik.setFieldTouched("progress", true)
                                                }
                                                isLoading={progressesLoading}
                                                components={{
                                                    Option: ({ option }) => (
                                                        <div className="d-flex justify-content-between w-100 gap-8 px-3 py-2">
                                                            {settings.feature_invoice && invoiceSettings && !invoiceSettingsLoading && typeLog === 'default' && invoiceSettings.length > 0 ?
                                                                invoiceSettings.some((inv: InvoiceMultiPageSetting) => { return inv.progress?.id === option.value })
                                                                    ? <><span>{option.label}</span> <Badge bg="success">{intl.formatMessage({ id: 'INVOICE.LABEL.SEND_INVOICE' })}</Badge></>
                                                                    : option.label
                                                                : option.label
                                                            }
                                                        </div>
                                                    ),
                                                }}
                                            />
                                        </div>
                                        {formik.touched.progress && formik.errors.progress && (
                                            <div className='text-danger fv-plugins-message-container'>
                                                <span role='alert' className="text-danger">{formik.errors.progress}</span>
                                            </div>
                                        )}
                                        {
                                            (formik.values.progress && subProgressesData.length > 0) &&
                                            <>
                                                <label className='form-label text-dark fs-6 fw-bolder required'>{intl.formatMessage({ id: "FORM.LABEL.SUBPROGRESS" })}</label>
                                                <div className="input-group mb-3">
                                                    <VirtualizedSelect
                                                        className={clsx("w-100")}
                                                        name="subProgress"
                                                        placeholder={`${intl.formatMessage({ id: "FORM.ACTION.CHOOSE" })} ${intl.formatMessage({ id: "FORM.LABEL.SUBPROGRESS" })}`}
                                                        options={subProgressesData}
                                                        value={subProgressesData.find(option => {
                                                            return option.value === formik.values.subProgress
                                                        }) || null}
                                                        onChange={
                                                            option => formik.handleChange({
                                                                target: {
                                                                    name: "subProgress",
                                                                    value: option?.value || ''
                                                                }
                                                            })
                                                        }
                                                        onBlur={
                                                            () => formik.values.subProgress === "" && formik.setFieldTouched("subProgress", true)
                                                        }
                                                        isLoading={subProgressesLoading}
                                                        isDisabled={subProgressesLoading}
                                                    />
                                                </div>
                                                {formik.touched.subProgress && formik.errors.subProgress && (
                                                    <div className='text-danger fv-plugins-message-container'>
                                                        <span role='alert' className="text-danger">{formik.errors.subProgress}</span>
                                                    </div>
                                                )}
                                            </>
                                        }
                                        {customFieldLog && !customFieldLogLoading && Object.keys(customFieldLog).length > 0 && (
                                            <RenderCustomFieldGeneralForm
                                                customFieldGeneral={customFieldLog}
                                                formik={formik}
                                                errors={formik.errors}
                                                containerRef={document.querySelector(`#tambah-log-modal`) as HTMLElement}
                                                typeAction="update"
                                                typeForm={typeLog}
                                            />
                                        )}
                                        {
                                            (isLabelRequired(formik.values.progress)) &&
                                            <>
                                                <label className='form-label text-dark fs-6 fw-bolder required'>{intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}</label>
                                                <div className="input-group mb-3">
                                                    <Select
                                                        closeMenuOnSelect={false}
                                                        openMenuOnClick
                                                        isMulti
                                                        options={labelsData}
                                                        placeholder={`${intl.formatMessage({ id: 'FORM.ACTION.CHOOSE' })} ${intl.formatMessage({ id: 'FORM.LABEL.LABELS' })}`}
                                                        value={labelsData && Array.isArray(labelsData)
                                                            ? labelsData.filter((option: any) =>
                                                                formik.values.labels.includes(option.value)
                                                            )
                                                            : []}
                                                        onChange={(selectedOptions) => {
                                                            const selectedValues = selectedOptions
                                                                ? selectedOptions.map((option: any) => option.value)
                                                                : []
                                                            formik.setFieldValue('labels', selectedValues)
                                                        }}
                                                        className='w-100'
                                                        onBlur={() =>
                                                            formik.values.labels === '' &&
                                                            formik.setFieldTouched('labels', true)
                                                        }
                                                        isLoading={labelLoading}
                                                        isDisabled={labelLoading}
                                                    />
                                                </div>
                                                {formik.touched.labels && formik.errors.labels && (
                                                    <div className='fv-plugins-message-container text-danger'>
                                                        <span role='alert' className="text-danger">{formik.errors.labels}</span>
                                                    </div>
                                                )}
                                            </>
                                        }
                                        {
                                            (formik.values.progress && typeProgress === 'SUCCESS')
                                            && isSplitTableTermin && !(lead as Pipeline).date_end && showCheckboxPaidOffTermin() &&
                                            <div>
                                                <div className='d-flex align-content-center justify-content-start fv-plugins-message-container my-5'>
                                                    <input id="checkListProgress" type="checkbox"
                                                        className="me-2" checked={toggleCheckbox} onChange={() => {
                                                            if (tempPaymentTermin.length > 0) {
                                                                Swal.fire({
                                                                    icon: 'warning',
                                                                    title: intl.formatMessage({ id: 'FORM.LABEL.WARNING' }),
                                                                    text: intl.formatMessage({ id: 'FORM.LABEL.WARNING_RESET_TERMIN' }),
                                                                    confirmButtonText: intl.formatMessage({ id: 'FORM.ACTION.YES' }),
                                                                    cancelButtonText: intl.formatMessage({ id: 'FORM.ACTION.CANCEL' }),
                                                                    showCancelButton: true,
                                                                    showConfirmButton: true,
                                                                    reverseButtons: true,
                                                                    heightAuto: false,
                                                                }).then((result) => {
                                                                    if (result.isConfirmed) {
                                                                        setToggleCheckbox(!toggleCheckbox);
                                                                    }
                                                                });
                                                            } else {
                                                                setToggleCheckbox(!toggleCheckbox);
                                                            }
                                                        }} />
                                                    <label className="form-check-label" htmlFor="checkListProgress">{intl.formatMessage({ id: 'FORM.LABEL.PAID_OFF' })}</label>
                                                </div>

                                                {!toggleCheckbox && (
                                                    <div className="g-2 row align-items-center mb-4">
                                                        <span className="mb-3">
                                                            <h5>{intl.formatMessage({ id: 'FORM.LABEL.REMAINING_AMOUNT' })} : {typeof remainingAmount === 'number' ? currencyFormatter(selectMultiPipeline.currencyIsRounded ? Math.round(remainingAmount) : remainingAmount, selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true }) : currencyFormatter(parseFormattedCurrency(remainingAmount), selectMultiPipeline.currencyIsRounded, selectMultiPipeline.currencyCode, { showPrefix: true })}</h5>
                                                        </span>
                                                        <div className="row">
                                                            <div className="col-md-3">
                                                                <div className="form-group">
                                                                    <label className="form-label text-dark fs-6 fw-bolder">{intl.formatMessage({ id: "FORM.LABEL.INPUT_TYPE" })}</label>
                                                                    <select
                                                                        className="form-select"
                                                                        value={formik.values.terminForm.inputType}
                                                                        onChange={(e) => formik.setFieldValue('terminForm.inputType', e.target.value)}
                                                                    >
                                                                        <option value="nominal">Nominal</option>
                                                                        <option value="percentage">Persentase</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-3">
                                                                <div className="form-group h-100">
                                                                    <div className="d-flex align-items-center h-100 pt-6">
                                                                        <label className='form-label text-dark fs-6 fw-bolder mb-0 me-3'>{intl.formatMessage({ id: 'FORM.ACTION.ALREADY_PAID' })}</label>
                                                                        <Switch
                                                                            checked={formik.values.terminForm.togglePayment}
                                                                            onChange={(e) => formik.setFieldValue('terminForm.togglePayment', e.target.checked)}
                                                                            inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {
                                                                tempPaymentTermin.length === 0 &&
                                                                <div className="col-md-3">
                                                                    <div className="input-group h-100">
                                                                        <div className='d-flex align-items-center h-100 pt-6 form-check form-check-custom form-check-solid' style={{ display: 'contents' }}>
                                                                            <label id="paymentDP" className='form-label text-dark fs-6 fw-bolder mb-0 me-3'>{intl.formatMessage({ id: 'FORM.LABEL.PAYMENT_DP' })}</label>
                                                                            <input
                                                                                id="paymentDP"
                                                                                className="form-check-input"
                                                                                type="checkbox"
                                                                                checked={formik.values.terminForm.isPaymentDP}
                                                                                onChange={(e) => formik.setFieldValue('terminForm.isPaymentDP', e.target.checked)}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            }
                                                        </div>
                                                        <div className="row mt-3">
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form-label text-dark fs-6 fw-bolder required">
                                                                        {formik.values.terminForm.inputType === 'nominal' ? intl.formatMessage({ id: "FORM.LABEL.PAYMENT_AMOUNT" }) : intl.formatMessage({ id: "FORM.LABEL.PAYMENT_PERCENTAGE" })}
                                                                    </label>
                                                                    <div className="input-group">
                                                                        <span className="input-group-text">
                                                                            {formik.values.terminForm.inputType === 'nominal' ? getCurrencySymbol(selectMultiPipeline.currencyCode) : '%'}
                                                                        </span>
                                                                        <input
                                                                            type="text"
                                                                            inputMode="numeric"
                                                                            className="form-control"
                                                                            placeholder={formik.values.terminForm.inputType === 'nominal' ? intl.formatMessage({ id: "FORM.LABEL.ENTER_PAYMENT_AMOUNT" }, { title: 'Nominal' }) : intl.formatMessage({ id: "FORM.LABEL.ENTER_PERCENTAGE" })}
                                                                            value={formik.values.terminForm.nominal}
                                                                            onChange={handleNominalPembayaranChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            {/* ppn termin */}
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    <label className="form-label text-dark fs-6 fw-bolder">
                                                                        {intl.formatMessage({ id: "FORM.LABEL.VAT" })}
                                                                    </label>
                                                                    <div className="input-group">
                                                                        <span className="input-group-text">%</span>
                                                                        <input
                                                                            type="text"
                                                                            inputMode="numeric"
                                                                            className="form-control"
                                                                            value={formik.values.terminForm.vatPercentage}
                                                                            onChange={handleVATTerminChange}
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-4">
                                                                <div className="form-group">
                                                                    {
                                                                        formik.values.terminForm.togglePayment ? (
                                                                            <>
                                                                                <label className="form-label text-dark fs-6 fw-bolder required">{intl.formatMessage({ id: "FORM.LABEL.PAYMENT_DATE" })}</label>
                                                                                <DatePicker
                                                                                    value={formik.values.terminForm.datePaid ? new Date(formik.values.terminForm.datePaid) : null}
                                                                                    onChange={(date) => handlePaymentDate(date, formik.values.terminForm.togglePayment)}
                                                                                    ranges={todayRange}
                                                                                    oneTap
                                                                                    editable={false}
                                                                                    format="dd MMM yyyy"
                                                                                    defaultValue={null}
                                                                                    calendarDefaultDate={tempPaymentTermin.length > 0 ? new Date(tempPaymentTermin[tempPaymentTermin.length - 1].datePaid || '') : new Date()}
                                                                                    style={{ width: "100%" }}
                                                                                    className="form-control p-1"
                                                                                    container={document.querySelector('#tambah-log-modal') as HTMLElement}
                                                                                    shouldDisableDate={isAfterToday}
                                                                                />
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <label className="form-label text-dark fs-6 fw-bolder required">{intl.formatMessage({ id: "FORM.LABEL.DEADLINE_PAYMENT" })}</label>
                                                                                <DatePicker
                                                                                    value={formik.values.terminForm.dateDue ? new Date(formik.values.terminForm.dateDue) : null}
                                                                                    onChange={(date) => handlePaymentDate(date, formik.values.terminForm.togglePayment)}
                                                                                    ranges={todayRange}
                                                                                    oneTap
                                                                                    editable={false}
                                                                                    format="dd MMM yyyy"
                                                                                    defaultValue={null}
                                                                                    calendarDefaultDate={tempPaymentTermin.length > 0 ? new Date(tempPaymentTermin[tempPaymentTermin.length - 1].dateDue || '') : new Date()}
                                                                                    style={{ width: "100%" }}
                                                                                    className="form-control p-1"
                                                                                    container={document.querySelector('#tambah-log-modal') as HTMLElement}
                                                                                    shouldDisableDate={isDateDisabled}
                                                                                />
                                                                            </>
                                                                        )
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                        {/* Menampilkan error message */}
                                                        <div className="row">
                                                            <div className="col-md-4">
                                                                {/* Error messages */}
                                                                {terminErrors.nominal && (
                                                                    <span className="text-danger mt-3">{terminErrors.nominal}</span>
                                                                )}
                                                            </div>
                                                            <div className="col-md-4">
                                                                {/* Error messages */}
                                                                {terminErrors.vatPercentage && (
                                                                    <span className="text-danger mt-3">{terminErrors.vatPercentage}</span>
                                                                )}
                                                            </div>
                                                            <div className="col-md-4">
                                                                {terminErrors.dueDate && (
                                                                    <span className="text-danger mt-3">{terminErrors.dueDate}</span>
                                                                )}
                                                            </div>
                                                        </div>

                                                        <div className="row mt-3">
                                                            {formik.values.terminForm.togglePayment &&
                                                                <div className="col-md-8">
                                                                    <label className={`form-label fs-6 fw-bolder text-dark ${ALWAYS_REQUIRED_FIELDS_PROOF_OF_PAYMENT.includes(formik.values.progress) ? 'required' : ''}`}>{intl.formatMessage({ id: 'FORM.LABEL.PROOF_OF_PAYMENT_TERM' })}</label>
                                                                    <InputAttachmentTermin key={`formik.terminForm.receiptUrls`} keyString={`formik.terminForm.receiptUrls`} formik={formik} isMulti={false} type="input" accept="image/png, image/jpeg, image/jpg" typeCustomField='proofOfPayment' />
                                                                    {terminErrors.receiptUrls && (
                                                                        <span className="text-danger mt-3">{terminErrors.receiptUrls}</span>
                                                                    )}
                                                                </div>
                                                            }
                                                        </div>
                                                        {/* Render Custom Field Termin */}
                                                        <RenderTerminCustomFieldLog
                                                            customFieldTermin={customFieldTermin}
                                                            formik={formik}
                                                            errors={terminErrors}
                                                            inputRefs={refArray}
                                                        />
                                                        {/* Button Termin */}
                                                        <div className='col-md-12'>
                                                            <button
                                                                type="button"
                                                                className="btn btn-light-primary w-100"
                                                                onClick={handleAddPaymentTermin}
                                                            >
                                                                <i className="fa-plus fas"></i>
                                                                {intl.formatMessage({ id: "FORM.LABEL.ADD_GENERAL" }, { title: 'Termin' })}
                                                            </button>
                                                        </div>
                                                    </div>
                                                )}
                                                {tempPaymentTermin && tempPaymentTermin.length > 0 && (
                                                    <PaymentTerminDisplay onDeleteItem={handleDeleteItem} tempPaymentTermin={tempPaymentTermin} customFieldTermin={customFieldTermin} pipelineId={(lead as Pipeline).id} />
                                                )}
                                            </div>
                                        }
                                        <label className='form-label text-dark fs-6 fw-bolder required'>{intl.formatMessage({ id: "FORM.LABEL.DESCRIPTION" })}</label>
                                        <div className="input-group mb-15">
                                            <ReactQuill
                                                theme="snow"
                                                value={formik.values.description}
                                                onChange={(content, delta, source, editor) => {
                                                    formik.setFieldValue('description', content)
                                                }}
                                                formats={formats}
                                                modules={quillModules}
                                                ref={quillRef}
                                                style={{ height: 170, width: '100%' }}
                                                onBlur={() => {
                                                    formik.setFieldTouched('description', true)
                                                }}
                                                className={clsx('link',
                                                    { 'is-invalid': formik.touched.description && formik.errors.description },
                                                )}
                                            />
                                        </div>

                                        {formik.touched.description && formik.errors.description && (
                                            <div className='text-danger fv-plugins-message-container'>
                                                <span role='alert' className="text-danger">{formik.errors.description}</span>
                                            </div>
                                        )}
                                        <label className={`form-label fs-6 fw-bolder text-dark ${formik.values.isRequiredAttachment ? "required" : ""}`}>
                                            {intl.formatMessage({ id: "FORM.LABEL.ATTACHMENT" })}
                                        </label>
                                        <InputAttachment keyString={"attachment"} formik={formik} isMulti={true} type="update" accept="image/png, image/jpeg, image/jpg, application/pdf, application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document, application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation" typeForm={typeLog} />
                                        {formik.touched.attachment && formik.errors.attachment && (
                                            <div className='text-danger fv-plugins-message-container'>
                                                <span role='alert' className="text-danger">{formik.errors.attachment as string}</span>
                                            </div>
                                        )}
                                        {/* ------------------------------------------- Product List ------------------------------------------- */}
                                        {selectedProgress && isShowTableProduct(selectedProgress) && (
                                            <>
                                                <div className="separator separator-dashed my-10"></div>
                                                <button type="button" className="btn btn-primary w-100" onClick={() => {
                                                    if (tempPaymentTermin.some((item: any) => item.inputType === 'percentage')) {
                                                        handleAlertAddProduct(intl.formatMessage({ id: 'FORM.LABEL.CREATE' }).toLocaleLowerCase())
                                                    } else {
                                                        setShowModalAddProduct(true)
                                                        setTypeActionProduct('add')
                                                        setProductTemp({} as ListProduct)
                                                    }
                                                }}>
                                                    <i className="fas fa-plus me-2"></i> {intl.formatMessage({ id: "FORM.ACTION.ADD_PRODUCT" })}
                                                </button>
                                                <ListProductPipeline listProducts={listProducts} setListProducts={setListProducts} setShowModalAddProduct={setShowModalAddProduct} handleAlertAddProduct={handleAlertAddProduct} tempPaymentTermin={tempPaymentTermin} />
                                            </>
                                        )}
                                    </div>

                                    <div className="modal-footer">
                                        {stepForm === 0 && (
                                            <>
                                                <button
                                                    type="button"
                                                    className="d-none btn btn-light"
                                                    data-bs-dismiss="modal"
                                                    ref={closeModalRef}
                                                >
                                                    {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-light"
                                                    onClick={() => handleModalClose()}
                                                >
                                                    {intl.formatMessage({ id: "FORM.ACTION.CANCEL" })}
                                                </button>
                                            </>
                                        )}
                                        {settings.feature_invoice && hasInvoiceSettings && stepForm === 0 &&
                                            <button type="submit" className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`} data-kt-indicator={modalBtnLoading ? 'on' : 'off'} disabled={subProgressesLoading ? true : false || (!toggleCheckbox && tempPaymentTermin.length === 0) ? true : false || !formik.values.progress || labelLoading ? true : false}>
                                                <span className="indicator-label">
                                                    {intl.formatMessage({ id: 'FORM.ACTION.CONTINUE' })} <EastIcon />
                                                </span>
                                                <span className="indicator-progress">
                                                    Loading... <span className="align-middle ms-2 spinner-border spinner-border-sm"></span>
                                                </span>
                                            </button>
                                        }
                                        {!hasInvoiceSettings && stepForm === 0 &&
                                            <button type="submit" className={`btn btn-primary me-10 ${modalBtnLoading ? 'disabled' : ''}`} data-kt-indicator={modalBtnLoading ? 'on' : 'off'} disabled={subProgressesLoading ? true : false || (!toggleCheckbox && tempPaymentTermin.length === 0) ? true : false || !formik.values.progress || labelLoading ? true : false}>
                                                <span className="indicator-label">
                                                    {typeAction === 'edit' ? intl.formatMessage({ id: "FORM.ACTION.UPDATE" }) : intl.formatMessage({ id: "FORM.ACTION.ADD" })}
                                                </span>
                                                <span className="indicator-progress">
                                                    Loading... <span className="align-middle ms-2 spinner-border spinner-border-sm"></span>
                                                </span>
                                            </button>
                                        }
                                    </div>
                                </form>
                            )}
                            {stepForm === 1 && selectInvoice && (
                                <InvoiceAttachments
                                    lead={lead}
                                    invoice={selectInvoice}
                                    context={'send-whatsapp'}
                                    routerContext="add-log"
                                    showInvoiceModal={showModal}
                                    handleInvoiceModalClose={(isSkipAlert) => {
                                        handleModalClose(isSkipAlert)
                                    }}
                                    closeModalRef={closeModalRef}
                                />
                            )}
                        </div>
                    </div>
                </div>
            </div>

            {
                showModalAddProduct &&
                <ProductPipelineMain
                    products={dataLeadAccess?.leadProducts ?? []}
                    completeProducts={dataLeadAccess?.completeLeadProducts ?? []}
                    productLoading={isLoadingLeadAccess}
                    listProducts={listProducts}
                    setListProducts={setListProducts}
                    typeForm="addLog"
                    onModalClose={() => setShowModalAddProduct(false)}
                    selectedProgress={selectedProgress}
                />
            }
        </>

    )
}

export { AddLog }